export default "__VITE_ASSET__86G9Qh9K__"